import HypurApi from '../../../../api/HypurApi';
import UserStore from '../../../../stores/UserStore';

class HypurCheckout extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            clients: [],
            selectedClient: null,
            pin: '',
        };

        this.doCheckout = this.doCheckout.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: true });
        HypurApi.loadCheckedInClients(UserStore.getApiData()).then(resp => {
            if(resp.Result) {
                var clients = resp.Data;
                this.setState({ clients });
            }
            this.setState({ loading: false });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    doCheckout() {
        var data = {
            CheckInISN: this.state.selectedClient.CheckInISN,
            IndividualISN: this.state.selectedClient.IndividualISN,
            Pin: this.state.pin
        }
        this.props.onComplete(data);
    }

    cancel() {
        this.props.onCancel();
    }

    render() {
        var guest = this.props.guest;
        var valid = this.state.pin.length > 0;
        return (
            <div className='checkout-completed'>
                <div className='checkout-completed__title' style={{height: 40, lineHeight: '40px'}}>
                    { !!this.state.selectedClient ? 'Enter Client PIN' : 'Hypur Client List' }
                </div>
                {
                    !!this.state.selectedClient ?
                    <div>
                        <div className="checkout-input">
                            <input
                                style={{
                                    position: 'absolute', top: 0, left: 0, width: 140
                                }}
                                type="password"
                                onChange={e => this.setState({ pin: e.target.value })}
                            />
                        </div>
                        
                    </div>
                    :
                    <div style={{height: 270, overflowY: 'scroll', marginTop: 10 }}>
                        {
                        _.map(this.state.clients, c =>
                            <div
                                onClick={() => this.setState({ selectedClient: c })}
                                style={{ marginLeft: 20, marginBottom: 5, cursor: 'pointer' }}>
                                <img src={'data:image/jpeg;base64, '+c.IndividualBase64Thumbnail} />
                                <div style={{ display: 'inline', marginLeft: 10}}>
                                    { c.IndividualName }
                                </div>
                            </div>
                        )
                        }
                    </div>
                }
                <div className='row' style={{margin:0}}>
                <div
                    style={{
                        display: 'block', left: 40, width: 120, margin: '0 auto', marginBottom: 10, marginTop: 10,
                    }}
                    className={'btn-red'}
                    onClick={this.cancel}>
                    Cancel
                </div>
                {!!this.state.selectedClient ? 
                    <div
                        style={{
                            display: 'block', left: 40, width: 120, margin: '0 auto', marginBottom: 10, marginTop: 10,
                        }}
                        className={'btn-green'}
                        onClick={this.doCheckout}>
                        CHECKOUT
                    </div> : false 
                }

                </div>
            </div>
        );
    }
}

export default HypurCheckout;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/electronic/HypurCheckout.react.jsx